export default function getNodeBackgroundImage(node) {
  if (node) {
    return node.style.backgroundImage || null
  } else {
    return null
  }
}
